export enum ErrorState {
  FailedCreateStream = "Failed to create stream.",
  FailedUpdateStream = "Failed to update stream.",
  FailedToFetchStreams = "Failed to fetch streams.",
  FailedToFetchStream = "Failed to fetch stream.",
  FailedToDeleteStream = "Failed to delete stream.",
  FailedToFetchBroadcastSettings = "Failed to fetch stream broadcast settings.",
  FailedToFetchPlaybackUrl = "Failed to fetch stream playback url.",
  FailedToFetchViewerCount = "Failed to fetch viewer count.",
  FailedToReactToStream = "Failed to react to stream.",
  FailedToVerifyPassword = "Failed to verify password.",
  FailedToFetchStreamState = "Failed to fetch stream state.",
  MaximumNumberOfStreamsReached = "Maximum number of channels reached.",
  FailedToRefreshToken = "Failed to refresh token.",
}
